<template>
    <div
        class="PageBuilderColumns"
    >
        <div
            class="grid grid--xlarge"
        >
            <div class="grid__item lap-and-up-one-third">
                <div
                    v-for="field in block.leftColumn"
                    :key="field.id"
                    class="PageBuilderColumns__field"
                >
                    <BaseText
                        v-if="field.text"
                        :text="field.text"
                    />

                    <BaseImage
                        v-if="field.srcset"
                        :placeholder="field.placeholder"
                        :srcset="field.srcset"
                        :ratio="1"
                    />

                    <BaseText
                        v-if="field.caption && field.srcset"
                        :text="field.caption"
                        classes="small heavier mt-small"
                    />
                </div>
            </div>
            <div class="grid__item lap-and-up-two-thirds">
                <div
                    v-for="field in block.rightColumn"
                    :key="field.id"
                    class="PageBuilderColumns__field PageBuilderColumns__field--right"
                >
                    <BaseText
                        v-if="field.text"
                        :text="field.text"
                    />

                    <BaseImage
                        v-if="field.srcset"
                        :placeholder="field.placeholder"
                        :srcset="field.srcset"
                        :ratio="1.6"
                    />

                    <BaseText
                        v-if="field.caption && field.srcset"
                        :text="field.caption"
                        classes="small heavier mt-small"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageBuilderColumns',
    props: {
        block: {
            type: Object,
            default: null
        }
    }
}
</script>
<style lang="scss" scoped>
    .PageBuilderColumns__field {
        margin-bottom: 55px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .PageBuilderColumns > .container {
        padding-right: 0;
        padding-left: 0;
        padding-top: getSpacing('medium');
        padding-bottom: getSpacing('medium');
    }

    .PageBuilderColumns__field--right {
        @include media-query(lap) {
            padding-left: getSpacing('large')
        }
        @include media-query(desk) {
            padding-left: getSpacing('xlarge')
        }
        @include media-query(palm) {
            padding-top: getSpacing('spacer')
        }
    }


</style>
